import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../services/api";
import { useAuthStore } from "../stores/authStore";

export default function Families() {
  const { hasPermission } = useAuthStore();
  const navigate = useNavigate();
  const [families, setFamilies] = useState<any[]>([]);
  const [search,   setSearch]   = useState("");
  const [loading,  setLoading]  = useState(false);

  async function load(q?: string) {
    setLoading(true);
    try { const r = await adminApi.listFamilies(q); setFamilies(r.families); }
    finally { setLoading(false); }
  }

  useEffect(() => { load(); }, []);

  if (!hasPermission("families:read")) {
    return <div className="card" style={{ color: "var(--text-muted)" }}>You do not have permission to view families.</div>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <h1 style={{ fontSize: 20, fontWeight: 900 }}>👨‍👩‍👧 Families</h1>
        <input
          placeholder="Search name, email, or ID…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && load(search)}
          style={{ flex: 1, padding: "8px 14px", borderRadius: 8, border: "1px solid var(--border)", background: "var(--surface2)", color: "var(--text)", fontSize: 13 }}
        />
        <button className="btn btn-primary" onClick={() => load(search)} disabled={loading}>Search</button>
      </div>

      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "var(--surface2)", color: "var(--text-muted)", fontSize: 11, textTransform: "uppercase", letterSpacing: ".07em" }}>
              <th style={{ padding: "10px 16px", textAlign: "left" }}>Name</th>
              <th style={{ padding: "10px 16px", textAlign: "left" }}>Owner</th>
              <th style={{ padding: "10px 16px", textAlign: "left" }}>Created</th>
              <th style={{ padding: "10px 16px", textAlign: "left" }}>Last Active</th>
            </tr>
          </thead>
          <tbody>
            {families.map((f) => (
              <tr key={f.familyId}
                onClick={() => navigate(`/families/${f.familyId}`)}
                style={{ borderTop: "1px solid var(--border)", cursor: "pointer" }}>
                <td style={{ padding: "10px 16px", fontWeight: 700 }}>{f.name}</td>
                <td style={{ padding: "10px 16px", color: "var(--text-muted)" }}>{f.parentEmail}</td>
                <td style={{ padding: "10px 16px", color: "var(--text-muted)", fontFamily: "monospace", fontSize: 11 }}>{f.createdAt?.slice(0,10)}</td>
                <td style={{ padding: "10px 16px", color: "var(--text-muted)", fontFamily: "monospace", fontSize: 11 }}>{f.lastActiveAt?.slice(0,10) ?? "—"}</td>
              </tr>
            ))}
            {families.length === 0 && !loading && (
              <tr><td colSpan={4} style={{ padding: 24, textAlign: "center", color: "var(--text-muted)" }}>No families found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
